// source: pbtypes/infrastructure/log_transform/log_transform.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_common_fault_pb = require('../../../pbtypes/gen/common/fault_pb.js');
goog.object.extend(proto, pbtypes_gen_common_fault_pb);
var pbtypes_gen_planner_planning_policy_pb = require('../../../pbtypes/gen/planner/planning_policy_pb.js');
goog.object.extend(proto, pbtypes_gen_planner_planning_policy_pb);
var pbtypes_gen_uuid_util_uuid_pb = require('../../../pbtypes/gen/uuid_util/uuid_pb.js');
goog.object.extend(proto, pbtypes_gen_uuid_util_uuid_pb);
goog.exportSymbol('proto.log_transform.AlwaysTrigger', null, global);
goog.exportSymbol('proto.log_transform.ChannelFilter', null, global);
goog.exportSymbol('proto.log_transform.CjiHint', null, global);
goog.exportSymbol('proto.log_transform.CjiMarkerSlice', null, global);
goog.exportSymbol('proto.log_transform.CompressionType', null, global);
goog.exportSymbol('proto.log_transform.ContentSelection', null, global);
goog.exportSymbol('proto.log_transform.ExternalTrigger', null, global);
goog.exportSymbol('proto.log_transform.ExternalTrigger.ExternalTriggerType', null, global);
goog.exportSymbol('proto.log_transform.FaultOnTrigger', null, global);
goog.exportSymbol('proto.log_transform.MarkSliceEnd', null, global);
goog.exportSymbol('proto.log_transform.MarkSliceReason', null, global);
goog.exportSymbol('proto.log_transform.MarkSliceRequest', null, global);
goog.exportSymbol('proto.log_transform.MarkSliceRequest.StartOrEndCase', null, global);
goog.exportSymbol('proto.log_transform.MarkSliceStart', null, global);
goog.exportSymbol('proto.log_transform.OnDemandSliceRequest', null, global);
goog.exportSymbol('proto.log_transform.PlanningPolicyTrigger', null, global);
goog.exportSymbol('proto.log_transform.ResolvedSlice', null, global);
goog.exportSymbol('proto.log_transform.ResolvedSliceDescription', null, global);
goog.exportSymbol('proto.log_transform.SliceLogEntry', null, global);
goog.exportSymbol('proto.log_transform.SliceLogEntry.EntryCase', null, global);
goog.exportSymbol('proto.log_transform.SliceSettings', null, global);
goog.exportSymbol('proto.log_transform.SliceSpecification', null, global);
goog.exportSymbol('proto.log_transform.StreamSelection', null, global);
goog.exportSymbol('proto.log_transform.StreamType', null, global);
goog.exportSymbol('proto.log_transform.TimeInterval', null, global);
goog.exportSymbol('proto.log_transform.Trigger', null, global);
goog.exportSymbol('proto.log_transform.Trigger.TriggerVariantCase', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.log_transform.TimeInterval = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.log_transform.TimeInterval, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.log_transform.TimeInterval.displayName = 'proto.log_transform.TimeInterval';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.log_transform.StreamSelection = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.log_transform.StreamSelection, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.log_transform.StreamSelection.displayName = 'proto.log_transform.StreamSelection';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.log_transform.ChannelFilter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.log_transform.ChannelFilter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.log_transform.ChannelFilter.displayName = 'proto.log_transform.ChannelFilter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.log_transform.ContentSelection = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.log_transform.ContentSelection.repeatedFields_, null);
};
goog.inherits(proto.log_transform.ContentSelection, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.log_transform.ContentSelection.displayName = 'proto.log_transform.ContentSelection';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.log_transform.ExternalTrigger = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.log_transform.ExternalTrigger, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.log_transform.ExternalTrigger.displayName = 'proto.log_transform.ExternalTrigger';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.log_transform.FaultOnTrigger = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.log_transform.FaultOnTrigger, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.log_transform.FaultOnTrigger.displayName = 'proto.log_transform.FaultOnTrigger';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.log_transform.AlwaysTrigger = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.log_transform.AlwaysTrigger, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.log_transform.AlwaysTrigger.displayName = 'proto.log_transform.AlwaysTrigger';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.log_transform.PlanningPolicyTrigger = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.log_transform.PlanningPolicyTrigger, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.log_transform.PlanningPolicyTrigger.displayName = 'proto.log_transform.PlanningPolicyTrigger';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.log_transform.Trigger = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.log_transform.Trigger.oneofGroups_);
};
goog.inherits(proto.log_transform.Trigger, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.log_transform.Trigger.displayName = 'proto.log_transform.Trigger';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.log_transform.SliceSpecification = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.log_transform.SliceSpecification, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.log_transform.SliceSpecification.displayName = 'proto.log_transform.SliceSpecification';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.log_transform.SliceSettings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.log_transform.SliceSettings.repeatedFields_, null);
};
goog.inherits(proto.log_transform.SliceSettings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.log_transform.SliceSettings.displayName = 'proto.log_transform.SliceSettings';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.log_transform.ResolvedSlice = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.log_transform.ResolvedSlice, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.log_transform.ResolvedSlice.displayName = 'proto.log_transform.ResolvedSlice';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.log_transform.CjiMarkerSlice = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.log_transform.CjiMarkerSlice, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.log_transform.CjiMarkerSlice.displayName = 'proto.log_transform.CjiMarkerSlice';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.log_transform.ResolvedSliceDescription = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.log_transform.ResolvedSliceDescription.repeatedFields_, null);
};
goog.inherits(proto.log_transform.ResolvedSliceDescription, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.log_transform.ResolvedSliceDescription.displayName = 'proto.log_transform.ResolvedSliceDescription';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.log_transform.OnDemandSliceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.log_transform.OnDemandSliceRequest.repeatedFields_, null);
};
goog.inherits(proto.log_transform.OnDemandSliceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.log_transform.OnDemandSliceRequest.displayName = 'proto.log_transform.OnDemandSliceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.log_transform.MarkSliceStart = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.log_transform.MarkSliceStart, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.log_transform.MarkSliceStart.displayName = 'proto.log_transform.MarkSliceStart';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.log_transform.MarkSliceEnd = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.log_transform.MarkSliceEnd, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.log_transform.MarkSliceEnd.displayName = 'proto.log_transform.MarkSliceEnd';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.log_transform.MarkSliceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.log_transform.MarkSliceRequest.oneofGroups_);
};
goog.inherits(proto.log_transform.MarkSliceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.log_transform.MarkSliceRequest.displayName = 'proto.log_transform.MarkSliceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.log_transform.SliceLogEntry = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.log_transform.SliceLogEntry.oneofGroups_);
};
goog.inherits(proto.log_transform.SliceLogEntry, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.log_transform.SliceLogEntry.displayName = 'proto.log_transform.SliceLogEntry';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.log_transform.TimeInterval.prototype.toObject = function(opt_includeInstance) {
  return proto.log_transform.TimeInterval.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.log_transform.TimeInterval} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.log_transform.TimeInterval.toObject = function(includeInstance, msg) {
  var f, obj = {
startUs: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
endUs: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.log_transform.TimeInterval}
 */
proto.log_transform.TimeInterval.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.log_transform.TimeInterval;
  return proto.log_transform.TimeInterval.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.log_transform.TimeInterval} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.log_transform.TimeInterval}
 */
proto.log_transform.TimeInterval.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStartUs(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEndUs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.log_transform.TimeInterval.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.log_transform.TimeInterval.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.log_transform.TimeInterval} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.log_transform.TimeInterval.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional int64 start_us = 1;
 * @return {number}
 */
proto.log_transform.TimeInterval.prototype.getStartUs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.log_transform.TimeInterval} returns this
 */
proto.log_transform.TimeInterval.prototype.setStartUs = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.log_transform.TimeInterval} returns this
 */
proto.log_transform.TimeInterval.prototype.clearStartUs = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.log_transform.TimeInterval.prototype.hasStartUs = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 end_us = 2;
 * @return {number}
 */
proto.log_transform.TimeInterval.prototype.getEndUs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.log_transform.TimeInterval} returns this
 */
proto.log_transform.TimeInterval.prototype.setEndUs = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.log_transform.TimeInterval} returns this
 */
proto.log_transform.TimeInterval.prototype.clearEndUs = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.log_transform.TimeInterval.prototype.hasEndUs = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.log_transform.StreamSelection.prototype.toObject = function(opt_includeInstance) {
  return proto.log_transform.StreamSelection.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.log_transform.StreamSelection} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.log_transform.StreamSelection.toObject = function(includeInstance, msg) {
  var f, obj = {
type: jspb.Message.getFieldWithDefault(msg, 1, 0),
index: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.log_transform.StreamSelection}
 */
proto.log_transform.StreamSelection.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.log_transform.StreamSelection;
  return proto.log_transform.StreamSelection.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.log_transform.StreamSelection} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.log_transform.StreamSelection}
 */
proto.log_transform.StreamSelection.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.log_transform.StreamType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIndex(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.log_transform.StreamSelection.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.log_transform.StreamSelection.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.log_transform.StreamSelection} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.log_transform.StreamSelection.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getIndex();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional StreamType type = 1;
 * @return {!proto.log_transform.StreamType}
 */
proto.log_transform.StreamSelection.prototype.getType = function() {
  return /** @type {!proto.log_transform.StreamType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.log_transform.StreamType} value
 * @return {!proto.log_transform.StreamSelection} returns this
 */
proto.log_transform.StreamSelection.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int32 index = 2;
 * @return {number}
 */
proto.log_transform.StreamSelection.prototype.getIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.log_transform.StreamSelection} returns this
 */
proto.log_transform.StreamSelection.prototype.setIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.log_transform.ChannelFilter.prototype.toObject = function(opt_includeInstance) {
  return proto.log_transform.ChannelFilter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.log_transform.ChannelFilter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.log_transform.ChannelFilter.toObject = function(includeInstance, msg) {
  var f, obj = {
channelId: jspb.Message.getFieldWithDefault(msg, 1, 0),
downsampleDt: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.log_transform.ChannelFilter}
 */
proto.log_transform.ChannelFilter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.log_transform.ChannelFilter;
  return proto.log_transform.ChannelFilter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.log_transform.ChannelFilter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.log_transform.ChannelFilter}
 */
proto.log_transform.ChannelFilter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setChannelId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setDownsampleDt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.log_transform.ChannelFilter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.log_transform.ChannelFilter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.log_transform.ChannelFilter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.log_transform.ChannelFilter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChannelId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getDownsampleDt();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
};


/**
 * optional uint32 channel_id = 1;
 * @return {number}
 */
proto.log_transform.ChannelFilter.prototype.getChannelId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.log_transform.ChannelFilter} returns this
 */
proto.log_transform.ChannelFilter.prototype.setChannelId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional float downsample_dt = 2;
 * @return {number}
 */
proto.log_transform.ChannelFilter.prototype.getDownsampleDt = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.log_transform.ChannelFilter} returns this
 */
proto.log_transform.ChannelFilter.prototype.setDownsampleDt = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.log_transform.ContentSelection.repeatedFields_ = [1,2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.log_transform.ContentSelection.prototype.toObject = function(opt_includeInstance) {
  return proto.log_transform.ContentSelection.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.log_transform.ContentSelection} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.log_transform.ContentSelection.toObject = function(includeInstance, msg) {
  var f, obj = {
streamsList: jspb.Message.toObjectList(msg.getStreamsList(),
    proto.log_transform.StreamSelection.toObject, includeInstance),
channelsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
downsampledChannelsList: jspb.Message.toObjectList(msg.getDownsampledChannelsList(),
    proto.log_transform.ChannelFilter.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.log_transform.ContentSelection}
 */
proto.log_transform.ContentSelection.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.log_transform.ContentSelection;
  return proto.log_transform.ContentSelection.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.log_transform.ContentSelection} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.log_transform.ContentSelection}
 */
proto.log_transform.ContentSelection.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.log_transform.StreamSelection;
      reader.readMessage(value,proto.log_transform.StreamSelection.deserializeBinaryFromReader);
      msg.addStreams(value);
      break;
    case 2:
      reader.readPackableUint32Into(msg.getChannelsList());
      break;
    case 3:
      var value = new proto.log_transform.ChannelFilter;
      reader.readMessage(value,proto.log_transform.ChannelFilter.deserializeBinaryFromReader);
      msg.addDownsampledChannels(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.log_transform.ContentSelection.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.log_transform.ContentSelection.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.log_transform.ContentSelection} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.log_transform.ContentSelection.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStreamsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.log_transform.StreamSelection.serializeBinaryToWriter
    );
  }
  f = message.getChannelsList();
  if (f.length > 0) {
    writer.writePackedUint32(
      2,
      f
    );
  }
  f = message.getDownsampledChannelsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.log_transform.ChannelFilter.serializeBinaryToWriter
    );
  }
};


/**
 * repeated StreamSelection streams = 1;
 * @return {!Array<!proto.log_transform.StreamSelection>}
 */
proto.log_transform.ContentSelection.prototype.getStreamsList = function() {
  return /** @type{!Array<!proto.log_transform.StreamSelection>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.log_transform.StreamSelection, 1));
};


/**
 * @param {!Array<!proto.log_transform.StreamSelection>} value
 * @return {!proto.log_transform.ContentSelection} returns this
*/
proto.log_transform.ContentSelection.prototype.setStreamsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.log_transform.StreamSelection=} opt_value
 * @param {number=} opt_index
 * @return {!proto.log_transform.StreamSelection}
 */
proto.log_transform.ContentSelection.prototype.addStreams = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.log_transform.StreamSelection, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.log_transform.ContentSelection} returns this
 */
proto.log_transform.ContentSelection.prototype.clearStreamsList = function() {
  return this.setStreamsList([]);
};


/**
 * repeated uint32 channels = 2;
 * @return {!Array<number>}
 */
proto.log_transform.ContentSelection.prototype.getChannelsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.log_transform.ContentSelection} returns this
 */
proto.log_transform.ContentSelection.prototype.setChannelsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.log_transform.ContentSelection} returns this
 */
proto.log_transform.ContentSelection.prototype.addChannels = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.log_transform.ContentSelection} returns this
 */
proto.log_transform.ContentSelection.prototype.clearChannelsList = function() {
  return this.setChannelsList([]);
};


/**
 * repeated ChannelFilter downsampled_channels = 3;
 * @return {!Array<!proto.log_transform.ChannelFilter>}
 */
proto.log_transform.ContentSelection.prototype.getDownsampledChannelsList = function() {
  return /** @type{!Array<!proto.log_transform.ChannelFilter>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.log_transform.ChannelFilter, 3));
};


/**
 * @param {!Array<!proto.log_transform.ChannelFilter>} value
 * @return {!proto.log_transform.ContentSelection} returns this
*/
proto.log_transform.ContentSelection.prototype.setDownsampledChannelsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.log_transform.ChannelFilter=} opt_value
 * @param {number=} opt_index
 * @return {!proto.log_transform.ChannelFilter}
 */
proto.log_transform.ContentSelection.prototype.addDownsampledChannels = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.log_transform.ChannelFilter, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.log_transform.ContentSelection} returns this
 */
proto.log_transform.ContentSelection.prototype.clearDownsampledChannelsList = function() {
  return this.setDownsampledChannelsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.log_transform.ExternalTrigger.prototype.toObject = function(opt_includeInstance) {
  return proto.log_transform.ExternalTrigger.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.log_transform.ExternalTrigger} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.log_transform.ExternalTrigger.toObject = function(includeInstance, msg) {
  var f, obj = {
triggerType: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.log_transform.ExternalTrigger}
 */
proto.log_transform.ExternalTrigger.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.log_transform.ExternalTrigger;
  return proto.log_transform.ExternalTrigger.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.log_transform.ExternalTrigger} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.log_transform.ExternalTrigger}
 */
proto.log_transform.ExternalTrigger.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.log_transform.ExternalTrigger.ExternalTriggerType} */ (reader.readEnum());
      msg.setTriggerType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.log_transform.ExternalTrigger.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.log_transform.ExternalTrigger.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.log_transform.ExternalTrigger} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.log_transform.ExternalTrigger.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTriggerType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.log_transform.ExternalTrigger.ExternalTriggerType = {
  EXTERNAL_TRIGGER_UNSPECIFIED: 0,
  EXTERNAL_TRIGGER_FOR_RETURN_TO_DOCK_DURATION: 1,
  EXTERNAL_TRIGGER_FLYING_TO_WAYPOINT: 2,
  EXTERNAL_TRIGGER_SUBJECT_TRACKING: 3,
  EXTERNAL_TRIGGER_OBSTACLE_PROXIMITY: 4,
  EXTERNAL_TRIGGER_CLIENT_AUTOFOCUS_REQUEST: 5
};

/**
 * optional ExternalTriggerType trigger_type = 1;
 * @return {!proto.log_transform.ExternalTrigger.ExternalTriggerType}
 */
proto.log_transform.ExternalTrigger.prototype.getTriggerType = function() {
  return /** @type {!proto.log_transform.ExternalTrigger.ExternalTriggerType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.log_transform.ExternalTrigger.ExternalTriggerType} value
 * @return {!proto.log_transform.ExternalTrigger} returns this
 */
proto.log_transform.ExternalTrigger.prototype.setTriggerType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.log_transform.FaultOnTrigger.prototype.toObject = function(opt_includeInstance) {
  return proto.log_transform.FaultOnTrigger.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.log_transform.FaultOnTrigger} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.log_transform.FaultOnTrigger.toObject = function(includeInstance, msg) {
  var f, obj = {
fault: jspb.Message.getFieldWithDefault(msg, 1, 0),
timeStartOffsetUs: jspb.Message.getFieldWithDefault(msg, 2, 0),
timeEndOffsetUs: jspb.Message.getFieldWithDefault(msg, 3, 0),
cooldownDurationSec: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.log_transform.FaultOnTrigger}
 */
proto.log_transform.FaultOnTrigger.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.log_transform.FaultOnTrigger;
  return proto.log_transform.FaultOnTrigger.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.log_transform.FaultOnTrigger} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.log_transform.FaultOnTrigger}
 */
proto.log_transform.FaultOnTrigger.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.common.VehicleFault.Enum} */ (reader.readEnum());
      msg.setFault(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTimeStartOffsetUs(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTimeEndOffsetUs(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCooldownDurationSec(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.log_transform.FaultOnTrigger.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.log_transform.FaultOnTrigger.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.log_transform.FaultOnTrigger} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.log_transform.FaultOnTrigger.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFault();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getTimeStartOffsetUs();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getTimeEndOffsetUs();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getCooldownDurationSec();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional common.VehicleFault.Enum fault = 1;
 * @return {!proto.common.VehicleFault.Enum}
 */
proto.log_transform.FaultOnTrigger.prototype.getFault = function() {
  return /** @type {!proto.common.VehicleFault.Enum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.common.VehicleFault.Enum} value
 * @return {!proto.log_transform.FaultOnTrigger} returns this
 */
proto.log_transform.FaultOnTrigger.prototype.setFault = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional int64 time_start_offset_us = 2;
 * @return {number}
 */
proto.log_transform.FaultOnTrigger.prototype.getTimeStartOffsetUs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.log_transform.FaultOnTrigger} returns this
 */
proto.log_transform.FaultOnTrigger.prototype.setTimeStartOffsetUs = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 time_end_offset_us = 3;
 * @return {number}
 */
proto.log_transform.FaultOnTrigger.prototype.getTimeEndOffsetUs = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.log_transform.FaultOnTrigger} returns this
 */
proto.log_transform.FaultOnTrigger.prototype.setTimeEndOffsetUs = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 cooldown_duration_sec = 4;
 * @return {number}
 */
proto.log_transform.FaultOnTrigger.prototype.getCooldownDurationSec = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.log_transform.FaultOnTrigger} returns this
 */
proto.log_transform.FaultOnTrigger.prototype.setCooldownDurationSec = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.log_transform.AlwaysTrigger.prototype.toObject = function(opt_includeInstance) {
  return proto.log_transform.AlwaysTrigger.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.log_transform.AlwaysTrigger} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.log_transform.AlwaysTrigger.toObject = function(includeInstance, msg) {
  var f, obj = {
utimeSinceLogstart: (f = msg.getUtimeSinceLogstart()) && proto.log_transform.TimeInterval.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.log_transform.AlwaysTrigger}
 */
proto.log_transform.AlwaysTrigger.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.log_transform.AlwaysTrigger;
  return proto.log_transform.AlwaysTrigger.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.log_transform.AlwaysTrigger} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.log_transform.AlwaysTrigger}
 */
proto.log_transform.AlwaysTrigger.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.log_transform.TimeInterval;
      reader.readMessage(value,proto.log_transform.TimeInterval.deserializeBinaryFromReader);
      msg.setUtimeSinceLogstart(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.log_transform.AlwaysTrigger.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.log_transform.AlwaysTrigger.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.log_transform.AlwaysTrigger} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.log_transform.AlwaysTrigger.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUtimeSinceLogstart();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.log_transform.TimeInterval.serializeBinaryToWriter
    );
  }
};


/**
 * optional TimeInterval utime_since_logstart = 1;
 * @return {?proto.log_transform.TimeInterval}
 */
proto.log_transform.AlwaysTrigger.prototype.getUtimeSinceLogstart = function() {
  return /** @type{?proto.log_transform.TimeInterval} */ (
    jspb.Message.getWrapperField(this, proto.log_transform.TimeInterval, 1));
};


/**
 * @param {?proto.log_transform.TimeInterval|undefined} value
 * @return {!proto.log_transform.AlwaysTrigger} returns this
*/
proto.log_transform.AlwaysTrigger.prototype.setUtimeSinceLogstart = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.log_transform.AlwaysTrigger} returns this
 */
proto.log_transform.AlwaysTrigger.prototype.clearUtimeSinceLogstart = function() {
  return this.setUtimeSinceLogstart(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.log_transform.AlwaysTrigger.prototype.hasUtimeSinceLogstart = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.log_transform.PlanningPolicyTrigger.prototype.toObject = function(opt_includeInstance) {
  return proto.log_transform.PlanningPolicyTrigger.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.log_transform.PlanningPolicyTrigger} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.log_transform.PlanningPolicyTrigger.toObject = function(includeInstance, msg) {
  var f, obj = {
policy: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.log_transform.PlanningPolicyTrigger}
 */
proto.log_transform.PlanningPolicyTrigger.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.log_transform.PlanningPolicyTrigger;
  return proto.log_transform.PlanningPolicyTrigger.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.log_transform.PlanningPolicyTrigger} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.log_transform.PlanningPolicyTrigger}
 */
proto.log_transform.PlanningPolicyTrigger.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.planner.PlanningPolicyPb.Enum} */ (reader.readEnum());
      msg.setPolicy(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.log_transform.PlanningPolicyTrigger.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.log_transform.PlanningPolicyTrigger.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.log_transform.PlanningPolicyTrigger} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.log_transform.PlanningPolicyTrigger.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPolicy();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional planner.PlanningPolicyPb.Enum policy = 1;
 * @return {!proto.planner.PlanningPolicyPb.Enum}
 */
proto.log_transform.PlanningPolicyTrigger.prototype.getPolicy = function() {
  return /** @type {!proto.planner.PlanningPolicyPb.Enum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.planner.PlanningPolicyPb.Enum} value
 * @return {!proto.log_transform.PlanningPolicyTrigger} returns this
 */
proto.log_transform.PlanningPolicyTrigger.prototype.setPolicy = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.log_transform.Trigger.oneofGroups_ = [[1,2,4,3]];

/**
 * @enum {number}
 */
proto.log_transform.Trigger.TriggerVariantCase = {
  TRIGGER_VARIANT_NOT_SET: 0,
  EXTERNAL_TRIGGER: 1,
  FAULT_ON_TRIGGER: 2,
  PLANNING_POLICY_TRIGGER: 4,
  ALWAYS_TRIGGER: 3
};

/**
 * @return {proto.log_transform.Trigger.TriggerVariantCase}
 */
proto.log_transform.Trigger.prototype.getTriggerVariantCase = function() {
  return /** @type {proto.log_transform.Trigger.TriggerVariantCase} */(jspb.Message.computeOneofCase(this, proto.log_transform.Trigger.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.log_transform.Trigger.prototype.toObject = function(opt_includeInstance) {
  return proto.log_transform.Trigger.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.log_transform.Trigger} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.log_transform.Trigger.toObject = function(includeInstance, msg) {
  var f, obj = {
externalTrigger: (f = msg.getExternalTrigger()) && proto.log_transform.ExternalTrigger.toObject(includeInstance, f),
faultOnTrigger: (f = msg.getFaultOnTrigger()) && proto.log_transform.FaultOnTrigger.toObject(includeInstance, f),
planningPolicyTrigger: (f = msg.getPlanningPolicyTrigger()) && proto.log_transform.PlanningPolicyTrigger.toObject(includeInstance, f),
alwaysTrigger: (f = msg.getAlwaysTrigger()) && proto.log_transform.AlwaysTrigger.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.log_transform.Trigger}
 */
proto.log_transform.Trigger.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.log_transform.Trigger;
  return proto.log_transform.Trigger.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.log_transform.Trigger} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.log_transform.Trigger}
 */
proto.log_transform.Trigger.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.log_transform.ExternalTrigger;
      reader.readMessage(value,proto.log_transform.ExternalTrigger.deserializeBinaryFromReader);
      msg.setExternalTrigger(value);
      break;
    case 2:
      var value = new proto.log_transform.FaultOnTrigger;
      reader.readMessage(value,proto.log_transform.FaultOnTrigger.deserializeBinaryFromReader);
      msg.setFaultOnTrigger(value);
      break;
    case 4:
      var value = new proto.log_transform.PlanningPolicyTrigger;
      reader.readMessage(value,proto.log_transform.PlanningPolicyTrigger.deserializeBinaryFromReader);
      msg.setPlanningPolicyTrigger(value);
      break;
    case 3:
      var value = new proto.log_transform.AlwaysTrigger;
      reader.readMessage(value,proto.log_transform.AlwaysTrigger.deserializeBinaryFromReader);
      msg.setAlwaysTrigger(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.log_transform.Trigger.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.log_transform.Trigger.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.log_transform.Trigger} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.log_transform.Trigger.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExternalTrigger();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.log_transform.ExternalTrigger.serializeBinaryToWriter
    );
  }
  f = message.getFaultOnTrigger();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.log_transform.FaultOnTrigger.serializeBinaryToWriter
    );
  }
  f = message.getPlanningPolicyTrigger();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.log_transform.PlanningPolicyTrigger.serializeBinaryToWriter
    );
  }
  f = message.getAlwaysTrigger();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.log_transform.AlwaysTrigger.serializeBinaryToWriter
    );
  }
};


/**
 * optional ExternalTrigger external_trigger = 1;
 * @return {?proto.log_transform.ExternalTrigger}
 */
proto.log_transform.Trigger.prototype.getExternalTrigger = function() {
  return /** @type{?proto.log_transform.ExternalTrigger} */ (
    jspb.Message.getWrapperField(this, proto.log_transform.ExternalTrigger, 1));
};


/**
 * @param {?proto.log_transform.ExternalTrigger|undefined} value
 * @return {!proto.log_transform.Trigger} returns this
*/
proto.log_transform.Trigger.prototype.setExternalTrigger = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.log_transform.Trigger.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.log_transform.Trigger} returns this
 */
proto.log_transform.Trigger.prototype.clearExternalTrigger = function() {
  return this.setExternalTrigger(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.log_transform.Trigger.prototype.hasExternalTrigger = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional FaultOnTrigger fault_on_trigger = 2;
 * @return {?proto.log_transform.FaultOnTrigger}
 */
proto.log_transform.Trigger.prototype.getFaultOnTrigger = function() {
  return /** @type{?proto.log_transform.FaultOnTrigger} */ (
    jspb.Message.getWrapperField(this, proto.log_transform.FaultOnTrigger, 2));
};


/**
 * @param {?proto.log_transform.FaultOnTrigger|undefined} value
 * @return {!proto.log_transform.Trigger} returns this
*/
proto.log_transform.Trigger.prototype.setFaultOnTrigger = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.log_transform.Trigger.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.log_transform.Trigger} returns this
 */
proto.log_transform.Trigger.prototype.clearFaultOnTrigger = function() {
  return this.setFaultOnTrigger(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.log_transform.Trigger.prototype.hasFaultOnTrigger = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional PlanningPolicyTrigger planning_policy_trigger = 4;
 * @return {?proto.log_transform.PlanningPolicyTrigger}
 */
proto.log_transform.Trigger.prototype.getPlanningPolicyTrigger = function() {
  return /** @type{?proto.log_transform.PlanningPolicyTrigger} */ (
    jspb.Message.getWrapperField(this, proto.log_transform.PlanningPolicyTrigger, 4));
};


/**
 * @param {?proto.log_transform.PlanningPolicyTrigger|undefined} value
 * @return {!proto.log_transform.Trigger} returns this
*/
proto.log_transform.Trigger.prototype.setPlanningPolicyTrigger = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.log_transform.Trigger.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.log_transform.Trigger} returns this
 */
proto.log_transform.Trigger.prototype.clearPlanningPolicyTrigger = function() {
  return this.setPlanningPolicyTrigger(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.log_transform.Trigger.prototype.hasPlanningPolicyTrigger = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional AlwaysTrigger always_trigger = 3;
 * @return {?proto.log_transform.AlwaysTrigger}
 */
proto.log_transform.Trigger.prototype.getAlwaysTrigger = function() {
  return /** @type{?proto.log_transform.AlwaysTrigger} */ (
    jspb.Message.getWrapperField(this, proto.log_transform.AlwaysTrigger, 3));
};


/**
 * @param {?proto.log_transform.AlwaysTrigger|undefined} value
 * @return {!proto.log_transform.Trigger} returns this
*/
proto.log_transform.Trigger.prototype.setAlwaysTrigger = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.log_transform.Trigger.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.log_transform.Trigger} returns this
 */
proto.log_transform.Trigger.prototype.clearAlwaysTrigger = function() {
  return this.setAlwaysTrigger(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.log_transform.Trigger.prototype.hasAlwaysTrigger = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.log_transform.SliceSpecification.prototype.toObject = function(opt_includeInstance) {
  return proto.log_transform.SliceSpecification.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.log_transform.SliceSpecification} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.log_transform.SliceSpecification.toObject = function(includeInstance, msg) {
  var f, obj = {
trigger: (f = msg.getTrigger()) && proto.log_transform.Trigger.toObject(includeInstance, f),
selection: (f = msg.getSelection()) && proto.log_transform.ContentSelection.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.log_transform.SliceSpecification}
 */
proto.log_transform.SliceSpecification.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.log_transform.SliceSpecification;
  return proto.log_transform.SliceSpecification.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.log_transform.SliceSpecification} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.log_transform.SliceSpecification}
 */
proto.log_transform.SliceSpecification.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.log_transform.Trigger;
      reader.readMessage(value,proto.log_transform.Trigger.deserializeBinaryFromReader);
      msg.setTrigger(value);
      break;
    case 2:
      var value = new proto.log_transform.ContentSelection;
      reader.readMessage(value,proto.log_transform.ContentSelection.deserializeBinaryFromReader);
      msg.setSelection(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.log_transform.SliceSpecification.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.log_transform.SliceSpecification.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.log_transform.SliceSpecification} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.log_transform.SliceSpecification.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTrigger();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.log_transform.Trigger.serializeBinaryToWriter
    );
  }
  f = message.getSelection();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.log_transform.ContentSelection.serializeBinaryToWriter
    );
  }
};


/**
 * optional Trigger trigger = 1;
 * @return {?proto.log_transform.Trigger}
 */
proto.log_transform.SliceSpecification.prototype.getTrigger = function() {
  return /** @type{?proto.log_transform.Trigger} */ (
    jspb.Message.getWrapperField(this, proto.log_transform.Trigger, 1));
};


/**
 * @param {?proto.log_transform.Trigger|undefined} value
 * @return {!proto.log_transform.SliceSpecification} returns this
*/
proto.log_transform.SliceSpecification.prototype.setTrigger = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.log_transform.SliceSpecification} returns this
 */
proto.log_transform.SliceSpecification.prototype.clearTrigger = function() {
  return this.setTrigger(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.log_transform.SliceSpecification.prototype.hasTrigger = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ContentSelection selection = 2;
 * @return {?proto.log_transform.ContentSelection}
 */
proto.log_transform.SliceSpecification.prototype.getSelection = function() {
  return /** @type{?proto.log_transform.ContentSelection} */ (
    jspb.Message.getWrapperField(this, proto.log_transform.ContentSelection, 2));
};


/**
 * @param {?proto.log_transform.ContentSelection|undefined} value
 * @return {!proto.log_transform.SliceSpecification} returns this
*/
proto.log_transform.SliceSpecification.prototype.setSelection = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.log_transform.SliceSpecification} returns this
 */
proto.log_transform.SliceSpecification.prototype.clearSelection = function() {
  return this.setSelection(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.log_transform.SliceSpecification.prototype.hasSelection = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.log_transform.SliceSettings.repeatedFields_ = [1,6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.log_transform.SliceSettings.prototype.toObject = function(opt_includeInstance) {
  return proto.log_transform.SliceSettings.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.log_transform.SliceSettings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.log_transform.SliceSettings.toObject = function(includeInstance, msg) {
  var f, obj = {
specificationsList: jspb.Message.toObjectList(msg.getSpecificationsList(),
    proto.log_transform.SliceSpecification.toObject, includeInstance),
compression: jspb.Message.getFieldWithDefault(msg, 2, 0),
compressionLevel: jspb.Message.getFieldWithDefault(msg, 3, 0),
enableSlicing: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
allSlicesAreNonCji: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
acceptedMarkSliceReasonsList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.log_transform.SliceSettings}
 */
proto.log_transform.SliceSettings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.log_transform.SliceSettings;
  return proto.log_transform.SliceSettings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.log_transform.SliceSettings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.log_transform.SliceSettings}
 */
proto.log_transform.SliceSettings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.log_transform.SliceSpecification;
      reader.readMessage(value,proto.log_transform.SliceSpecification.deserializeBinaryFromReader);
      msg.addSpecifications(value);
      break;
    case 2:
      var value = /** @type {!proto.log_transform.CompressionType} */ (reader.readEnum());
      msg.setCompression(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCompressionLevel(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableSlicing(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllSlicesAreNonCji(value);
      break;
    case 6:
      reader.readPackableEnumInto(msg.getAcceptedMarkSliceReasonsList());
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.log_transform.SliceSettings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.log_transform.SliceSettings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.log_transform.SliceSettings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.log_transform.SliceSettings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSpecificationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.log_transform.SliceSpecification.serializeBinaryToWriter
    );
  }
  f = message.getCompression();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getCompressionLevel();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getEnableSlicing();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getAllSlicesAreNonCji();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getAcceptedMarkSliceReasonsList();
  if (f.length > 0) {
    writer.writePackedEnum(
      6,
      f
    );
  }
};


/**
 * repeated SliceSpecification specifications = 1;
 * @return {!Array<!proto.log_transform.SliceSpecification>}
 */
proto.log_transform.SliceSettings.prototype.getSpecificationsList = function() {
  return /** @type{!Array<!proto.log_transform.SliceSpecification>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.log_transform.SliceSpecification, 1));
};


/**
 * @param {!Array<!proto.log_transform.SliceSpecification>} value
 * @return {!proto.log_transform.SliceSettings} returns this
*/
proto.log_transform.SliceSettings.prototype.setSpecificationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.log_transform.SliceSpecification=} opt_value
 * @param {number=} opt_index
 * @return {!proto.log_transform.SliceSpecification}
 */
proto.log_transform.SliceSettings.prototype.addSpecifications = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.log_transform.SliceSpecification, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.log_transform.SliceSettings} returns this
 */
proto.log_transform.SliceSettings.prototype.clearSpecificationsList = function() {
  return this.setSpecificationsList([]);
};


/**
 * optional CompressionType compression = 2;
 * @return {!proto.log_transform.CompressionType}
 */
proto.log_transform.SliceSettings.prototype.getCompression = function() {
  return /** @type {!proto.log_transform.CompressionType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.log_transform.CompressionType} value
 * @return {!proto.log_transform.SliceSettings} returns this
 */
proto.log_transform.SliceSettings.prototype.setCompression = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional int32 compression_level = 3;
 * @return {number}
 */
proto.log_transform.SliceSettings.prototype.getCompressionLevel = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.log_transform.SliceSettings} returns this
 */
proto.log_transform.SliceSettings.prototype.setCompressionLevel = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional bool enable_slicing = 4;
 * @return {boolean}
 */
proto.log_transform.SliceSettings.prototype.getEnableSlicing = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.log_transform.SliceSettings} returns this
 */
proto.log_transform.SliceSettings.prototype.setEnableSlicing = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool all_slices_are_non_cji = 5;
 * @return {boolean}
 */
proto.log_transform.SliceSettings.prototype.getAllSlicesAreNonCji = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.log_transform.SliceSettings} returns this
 */
proto.log_transform.SliceSettings.prototype.setAllSlicesAreNonCji = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * repeated MarkSliceReason accepted_mark_slice_reasons = 6;
 * @return {!Array<!proto.log_transform.MarkSliceReason>}
 */
proto.log_transform.SliceSettings.prototype.getAcceptedMarkSliceReasonsList = function() {
  return /** @type {!Array<!proto.log_transform.MarkSliceReason>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<!proto.log_transform.MarkSliceReason>} value
 * @return {!proto.log_transform.SliceSettings} returns this
 */
proto.log_transform.SliceSettings.prototype.setAcceptedMarkSliceReasonsList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {!proto.log_transform.MarkSliceReason} value
 * @param {number=} opt_index
 * @return {!proto.log_transform.SliceSettings} returns this
 */
proto.log_transform.SliceSettings.prototype.addAcceptedMarkSliceReasons = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.log_transform.SliceSettings} returns this
 */
proto.log_transform.SliceSettings.prototype.clearAcceptedMarkSliceReasonsList = function() {
  return this.setAcceptedMarkSliceReasonsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.log_transform.ResolvedSlice.prototype.toObject = function(opt_includeInstance) {
  return proto.log_transform.ResolvedSlice.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.log_transform.ResolvedSlice} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.log_transform.ResolvedSlice.toObject = function(includeInstance, msg) {
  var f, obj = {
utimeSinceBoot: (f = msg.getUtimeSinceBoot()) && proto.log_transform.TimeInterval.toObject(includeInstance, f),
content: (f = msg.getContent()) && proto.log_transform.ContentSelection.toObject(includeInstance, f),
sourceIndex: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
reason: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.log_transform.ResolvedSlice}
 */
proto.log_transform.ResolvedSlice.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.log_transform.ResolvedSlice;
  return proto.log_transform.ResolvedSlice.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.log_transform.ResolvedSlice} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.log_transform.ResolvedSlice}
 */
proto.log_transform.ResolvedSlice.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.log_transform.TimeInterval;
      reader.readMessage(value,proto.log_transform.TimeInterval.deserializeBinaryFromReader);
      msg.setUtimeSinceBoot(value);
      break;
    case 2:
      var value = new proto.log_transform.ContentSelection;
      reader.readMessage(value,proto.log_transform.ContentSelection.deserializeBinaryFromReader);
      msg.setContent(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSourceIndex(value);
      break;
    case 4:
      var value = /** @type {!proto.log_transform.MarkSliceReason} */ (reader.readEnum());
      msg.setReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.log_transform.ResolvedSlice.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.log_transform.ResolvedSlice.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.log_transform.ResolvedSlice} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.log_transform.ResolvedSlice.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUtimeSinceBoot();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.log_transform.TimeInterval.serializeBinaryToWriter
    );
  }
  f = message.getContent();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.log_transform.ContentSelection.serializeBinaryToWriter
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getReason();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * optional TimeInterval utime_since_boot = 1;
 * @return {?proto.log_transform.TimeInterval}
 */
proto.log_transform.ResolvedSlice.prototype.getUtimeSinceBoot = function() {
  return /** @type{?proto.log_transform.TimeInterval} */ (
    jspb.Message.getWrapperField(this, proto.log_transform.TimeInterval, 1));
};


/**
 * @param {?proto.log_transform.TimeInterval|undefined} value
 * @return {!proto.log_transform.ResolvedSlice} returns this
*/
proto.log_transform.ResolvedSlice.prototype.setUtimeSinceBoot = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.log_transform.ResolvedSlice} returns this
 */
proto.log_transform.ResolvedSlice.prototype.clearUtimeSinceBoot = function() {
  return this.setUtimeSinceBoot(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.log_transform.ResolvedSlice.prototype.hasUtimeSinceBoot = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ContentSelection content = 2;
 * @return {?proto.log_transform.ContentSelection}
 */
proto.log_transform.ResolvedSlice.prototype.getContent = function() {
  return /** @type{?proto.log_transform.ContentSelection} */ (
    jspb.Message.getWrapperField(this, proto.log_transform.ContentSelection, 2));
};


/**
 * @param {?proto.log_transform.ContentSelection|undefined} value
 * @return {!proto.log_transform.ResolvedSlice} returns this
*/
proto.log_transform.ResolvedSlice.prototype.setContent = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.log_transform.ResolvedSlice} returns this
 */
proto.log_transform.ResolvedSlice.prototype.clearContent = function() {
  return this.setContent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.log_transform.ResolvedSlice.prototype.hasContent = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 source_index = 3;
 * @return {number}
 */
proto.log_transform.ResolvedSlice.prototype.getSourceIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.log_transform.ResolvedSlice} returns this
 */
proto.log_transform.ResolvedSlice.prototype.setSourceIndex = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.log_transform.ResolvedSlice} returns this
 */
proto.log_transform.ResolvedSlice.prototype.clearSourceIndex = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.log_transform.ResolvedSlice.prototype.hasSourceIndex = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional MarkSliceReason reason = 4;
 * @return {!proto.log_transform.MarkSliceReason}
 */
proto.log_transform.ResolvedSlice.prototype.getReason = function() {
  return /** @type {!proto.log_transform.MarkSliceReason} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.log_transform.MarkSliceReason} value
 * @return {!proto.log_transform.ResolvedSlice} returns this
 */
proto.log_transform.ResolvedSlice.prototype.setReason = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.log_transform.CjiMarkerSlice.prototype.toObject = function(opt_includeInstance) {
  return proto.log_transform.CjiMarkerSlice.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.log_transform.CjiMarkerSlice} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.log_transform.CjiMarkerSlice.toObject = function(includeInstance, msg) {
  var f, obj = {
utimeSinceBoot: (f = msg.getUtimeSinceBoot()) && proto.log_transform.TimeInterval.toObject(includeInstance, f),
cjiHint: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.log_transform.CjiMarkerSlice}
 */
proto.log_transform.CjiMarkerSlice.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.log_transform.CjiMarkerSlice;
  return proto.log_transform.CjiMarkerSlice.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.log_transform.CjiMarkerSlice} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.log_transform.CjiMarkerSlice}
 */
proto.log_transform.CjiMarkerSlice.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.log_transform.TimeInterval;
      reader.readMessage(value,proto.log_transform.TimeInterval.deserializeBinaryFromReader);
      msg.setUtimeSinceBoot(value);
      break;
    case 2:
      var value = /** @type {!proto.log_transform.CjiHint} */ (reader.readEnum());
      msg.setCjiHint(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.log_transform.CjiMarkerSlice.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.log_transform.CjiMarkerSlice.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.log_transform.CjiMarkerSlice} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.log_transform.CjiMarkerSlice.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUtimeSinceBoot();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.log_transform.TimeInterval.serializeBinaryToWriter
    );
  }
  f = message.getCjiHint();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional TimeInterval utime_since_boot = 1;
 * @return {?proto.log_transform.TimeInterval}
 */
proto.log_transform.CjiMarkerSlice.prototype.getUtimeSinceBoot = function() {
  return /** @type{?proto.log_transform.TimeInterval} */ (
    jspb.Message.getWrapperField(this, proto.log_transform.TimeInterval, 1));
};


/**
 * @param {?proto.log_transform.TimeInterval|undefined} value
 * @return {!proto.log_transform.CjiMarkerSlice} returns this
*/
proto.log_transform.CjiMarkerSlice.prototype.setUtimeSinceBoot = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.log_transform.CjiMarkerSlice} returns this
 */
proto.log_transform.CjiMarkerSlice.prototype.clearUtimeSinceBoot = function() {
  return this.setUtimeSinceBoot(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.log_transform.CjiMarkerSlice.prototype.hasUtimeSinceBoot = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional CjiHint cji_hint = 2;
 * @return {!proto.log_transform.CjiHint}
 */
proto.log_transform.CjiMarkerSlice.prototype.getCjiHint = function() {
  return /** @type {!proto.log_transform.CjiHint} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.log_transform.CjiHint} value
 * @return {!proto.log_transform.CjiMarkerSlice} returns this
 */
proto.log_transform.CjiMarkerSlice.prototype.setCjiHint = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.log_transform.ResolvedSliceDescription.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.log_transform.ResolvedSliceDescription.prototype.toObject = function(opt_includeInstance) {
  return proto.log_transform.ResolvedSliceDescription.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.log_transform.ResolvedSliceDescription} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.log_transform.ResolvedSliceDescription.toObject = function(includeInstance, msg) {
  var f, obj = {
source: (f = msg.getSource()) && proto.log_transform.SliceSettings.toObject(includeInstance, f),
slicesList: jspb.Message.toObjectList(msg.getSlicesList(),
    proto.log_transform.ResolvedSlice.toObject, includeInstance),
cjiMarkerSlicesList: jspb.Message.toObjectList(msg.getCjiMarkerSlicesList(),
    proto.log_transform.CjiMarkerSlice.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.log_transform.ResolvedSliceDescription}
 */
proto.log_transform.ResolvedSliceDescription.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.log_transform.ResolvedSliceDescription;
  return proto.log_transform.ResolvedSliceDescription.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.log_transform.ResolvedSliceDescription} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.log_transform.ResolvedSliceDescription}
 */
proto.log_transform.ResolvedSliceDescription.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.log_transform.SliceSettings;
      reader.readMessage(value,proto.log_transform.SliceSettings.deserializeBinaryFromReader);
      msg.setSource(value);
      break;
    case 2:
      var value = new proto.log_transform.ResolvedSlice;
      reader.readMessage(value,proto.log_transform.ResolvedSlice.deserializeBinaryFromReader);
      msg.addSlices(value);
      break;
    case 3:
      var value = new proto.log_transform.CjiMarkerSlice;
      reader.readMessage(value,proto.log_transform.CjiMarkerSlice.deserializeBinaryFromReader);
      msg.addCjiMarkerSlices(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.log_transform.ResolvedSliceDescription.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.log_transform.ResolvedSliceDescription.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.log_transform.ResolvedSliceDescription} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.log_transform.ResolvedSliceDescription.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSource();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.log_transform.SliceSettings.serializeBinaryToWriter
    );
  }
  f = message.getSlicesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.log_transform.ResolvedSlice.serializeBinaryToWriter
    );
  }
  f = message.getCjiMarkerSlicesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.log_transform.CjiMarkerSlice.serializeBinaryToWriter
    );
  }
};


/**
 * optional SliceSettings source = 1;
 * @return {?proto.log_transform.SliceSettings}
 */
proto.log_transform.ResolvedSliceDescription.prototype.getSource = function() {
  return /** @type{?proto.log_transform.SliceSettings} */ (
    jspb.Message.getWrapperField(this, proto.log_transform.SliceSettings, 1));
};


/**
 * @param {?proto.log_transform.SliceSettings|undefined} value
 * @return {!proto.log_transform.ResolvedSliceDescription} returns this
*/
proto.log_transform.ResolvedSliceDescription.prototype.setSource = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.log_transform.ResolvedSliceDescription} returns this
 */
proto.log_transform.ResolvedSliceDescription.prototype.clearSource = function() {
  return this.setSource(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.log_transform.ResolvedSliceDescription.prototype.hasSource = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated ResolvedSlice slices = 2;
 * @return {!Array<!proto.log_transform.ResolvedSlice>}
 */
proto.log_transform.ResolvedSliceDescription.prototype.getSlicesList = function() {
  return /** @type{!Array<!proto.log_transform.ResolvedSlice>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.log_transform.ResolvedSlice, 2));
};


/**
 * @param {!Array<!proto.log_transform.ResolvedSlice>} value
 * @return {!proto.log_transform.ResolvedSliceDescription} returns this
*/
proto.log_transform.ResolvedSliceDescription.prototype.setSlicesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.log_transform.ResolvedSlice=} opt_value
 * @param {number=} opt_index
 * @return {!proto.log_transform.ResolvedSlice}
 */
proto.log_transform.ResolvedSliceDescription.prototype.addSlices = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.log_transform.ResolvedSlice, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.log_transform.ResolvedSliceDescription} returns this
 */
proto.log_transform.ResolvedSliceDescription.prototype.clearSlicesList = function() {
  return this.setSlicesList([]);
};


/**
 * repeated CjiMarkerSlice cji_marker_slices = 3;
 * @return {!Array<!proto.log_transform.CjiMarkerSlice>}
 */
proto.log_transform.ResolvedSliceDescription.prototype.getCjiMarkerSlicesList = function() {
  return /** @type{!Array<!proto.log_transform.CjiMarkerSlice>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.log_transform.CjiMarkerSlice, 3));
};


/**
 * @param {!Array<!proto.log_transform.CjiMarkerSlice>} value
 * @return {!proto.log_transform.ResolvedSliceDescription} returns this
*/
proto.log_transform.ResolvedSliceDescription.prototype.setCjiMarkerSlicesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.log_transform.CjiMarkerSlice=} opt_value
 * @param {number=} opt_index
 * @return {!proto.log_transform.CjiMarkerSlice}
 */
proto.log_transform.ResolvedSliceDescription.prototype.addCjiMarkerSlices = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.log_transform.CjiMarkerSlice, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.log_transform.ResolvedSliceDescription} returns this
 */
proto.log_transform.ResolvedSliceDescription.prototype.clearCjiMarkerSlicesList = function() {
  return this.setCjiMarkerSlicesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.log_transform.OnDemandSliceRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.log_transform.OnDemandSliceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.log_transform.OnDemandSliceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.log_transform.OnDemandSliceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.log_transform.OnDemandSliceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
requestId: (f = msg.getRequestId()) && pbtypes_gen_uuid_util_uuid_pb.Uuid.toObject(includeInstance, f),
logHandle: jspb.Message.getFieldWithDefault(msg, 2, ""),
specificationsList: jspb.Message.toObjectList(msg.getSpecificationsList(),
    proto.log_transform.SliceSpecification.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.log_transform.OnDemandSliceRequest}
 */
proto.log_transform.OnDemandSliceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.log_transform.OnDemandSliceRequest;
  return proto.log_transform.OnDemandSliceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.log_transform.OnDemandSliceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.log_transform.OnDemandSliceRequest}
 */
proto.log_transform.OnDemandSliceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new pbtypes_gen_uuid_util_uuid_pb.Uuid;
      reader.readMessage(value,pbtypes_gen_uuid_util_uuid_pb.Uuid.deserializeBinaryFromReader);
      msg.setRequestId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setLogHandle(value);
      break;
    case 3:
      var value = new proto.log_transform.SliceSpecification;
      reader.readMessage(value,proto.log_transform.SliceSpecification.deserializeBinaryFromReader);
      msg.addSpecifications(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.log_transform.OnDemandSliceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.log_transform.OnDemandSliceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.log_transform.OnDemandSliceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.log_transform.OnDemandSliceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      pbtypes_gen_uuid_util_uuid_pb.Uuid.serializeBinaryToWriter
    );
  }
  f = message.getLogHandle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSpecificationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.log_transform.SliceSpecification.serializeBinaryToWriter
    );
  }
};


/**
 * optional uuid_util.Uuid request_id = 1;
 * @return {?proto.uuid_util.Uuid}
 */
proto.log_transform.OnDemandSliceRequest.prototype.getRequestId = function() {
  return /** @type{?proto.uuid_util.Uuid} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_uuid_util_uuid_pb.Uuid, 1));
};


/**
 * @param {?proto.uuid_util.Uuid|undefined} value
 * @return {!proto.log_transform.OnDemandSliceRequest} returns this
*/
proto.log_transform.OnDemandSliceRequest.prototype.setRequestId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.log_transform.OnDemandSliceRequest} returns this
 */
proto.log_transform.OnDemandSliceRequest.prototype.clearRequestId = function() {
  return this.setRequestId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.log_transform.OnDemandSliceRequest.prototype.hasRequestId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string log_handle = 2;
 * @return {string}
 */
proto.log_transform.OnDemandSliceRequest.prototype.getLogHandle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.log_transform.OnDemandSliceRequest} returns this
 */
proto.log_transform.OnDemandSliceRequest.prototype.setLogHandle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated SliceSpecification specifications = 3;
 * @return {!Array<!proto.log_transform.SliceSpecification>}
 */
proto.log_transform.OnDemandSliceRequest.prototype.getSpecificationsList = function() {
  return /** @type{!Array<!proto.log_transform.SliceSpecification>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.log_transform.SliceSpecification, 3));
};


/**
 * @param {!Array<!proto.log_transform.SliceSpecification>} value
 * @return {!proto.log_transform.OnDemandSliceRequest} returns this
*/
proto.log_transform.OnDemandSliceRequest.prototype.setSpecificationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.log_transform.SliceSpecification=} opt_value
 * @param {number=} opt_index
 * @return {!proto.log_transform.SliceSpecification}
 */
proto.log_transform.OnDemandSliceRequest.prototype.addSpecifications = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.log_transform.SliceSpecification, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.log_transform.OnDemandSliceRequest} returns this
 */
proto.log_transform.OnDemandSliceRequest.prototype.clearSpecificationsList = function() {
  return this.setSpecificationsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.log_transform.MarkSliceStart.prototype.toObject = function(opt_includeInstance) {
  return proto.log_transform.MarkSliceStart.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.log_transform.MarkSliceStart} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.log_transform.MarkSliceStart.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: (f = msg.getUuid()) && pbtypes_gen_uuid_util_uuid_pb.Uuid.toObject(includeInstance, f),
startUtime: jspb.Message.getFieldWithDefault(msg, 2, 0),
endUtime: jspb.Message.getFieldWithDefault(msg, 3, 0),
trigger: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.log_transform.MarkSliceStart}
 */
proto.log_transform.MarkSliceStart.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.log_transform.MarkSliceStart;
  return proto.log_transform.MarkSliceStart.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.log_transform.MarkSliceStart} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.log_transform.MarkSliceStart}
 */
proto.log_transform.MarkSliceStart.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new pbtypes_gen_uuid_util_uuid_pb.Uuid;
      reader.readMessage(value,pbtypes_gen_uuid_util_uuid_pb.Uuid.deserializeBinaryFromReader);
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStartUtime(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEndUtime(value);
      break;
    case 6:
      var value = /** @type {!proto.log_transform.ExternalTrigger.ExternalTriggerType} */ (reader.readEnum());
      msg.setTrigger(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.log_transform.MarkSliceStart.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.log_transform.MarkSliceStart.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.log_transform.MarkSliceStart} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.log_transform.MarkSliceStart.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      pbtypes_gen_uuid_util_uuid_pb.Uuid.serializeBinaryToWriter
    );
  }
  f = message.getStartUtime();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getEndUtime();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getTrigger();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
};


/**
 * optional uuid_util.Uuid uuid = 1;
 * @return {?proto.uuid_util.Uuid}
 */
proto.log_transform.MarkSliceStart.prototype.getUuid = function() {
  return /** @type{?proto.uuid_util.Uuid} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_uuid_util_uuid_pb.Uuid, 1));
};


/**
 * @param {?proto.uuid_util.Uuid|undefined} value
 * @return {!proto.log_transform.MarkSliceStart} returns this
*/
proto.log_transform.MarkSliceStart.prototype.setUuid = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.log_transform.MarkSliceStart} returns this
 */
proto.log_transform.MarkSliceStart.prototype.clearUuid = function() {
  return this.setUuid(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.log_transform.MarkSliceStart.prototype.hasUuid = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 start_utime = 2;
 * @return {number}
 */
proto.log_transform.MarkSliceStart.prototype.getStartUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.log_transform.MarkSliceStart} returns this
 */
proto.log_transform.MarkSliceStart.prototype.setStartUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 end_utime = 3;
 * @return {number}
 */
proto.log_transform.MarkSliceStart.prototype.getEndUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.log_transform.MarkSliceStart} returns this
 */
proto.log_transform.MarkSliceStart.prototype.setEndUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional ExternalTrigger.ExternalTriggerType trigger = 6;
 * @return {!proto.log_transform.ExternalTrigger.ExternalTriggerType}
 */
proto.log_transform.MarkSliceStart.prototype.getTrigger = function() {
  return /** @type {!proto.log_transform.ExternalTrigger.ExternalTriggerType} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.log_transform.ExternalTrigger.ExternalTriggerType} value
 * @return {!proto.log_transform.MarkSliceStart} returns this
 */
proto.log_transform.MarkSliceStart.prototype.setTrigger = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.log_transform.MarkSliceEnd.prototype.toObject = function(opt_includeInstance) {
  return proto.log_transform.MarkSliceEnd.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.log_transform.MarkSliceEnd} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.log_transform.MarkSliceEnd.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: (f = msg.getUuid()) && pbtypes_gen_uuid_util_uuid_pb.Uuid.toObject(includeInstance, f),
endUtime: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.log_transform.MarkSliceEnd}
 */
proto.log_transform.MarkSliceEnd.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.log_transform.MarkSliceEnd;
  return proto.log_transform.MarkSliceEnd.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.log_transform.MarkSliceEnd} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.log_transform.MarkSliceEnd}
 */
proto.log_transform.MarkSliceEnd.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new pbtypes_gen_uuid_util_uuid_pb.Uuid;
      reader.readMessage(value,pbtypes_gen_uuid_util_uuid_pb.Uuid.deserializeBinaryFromReader);
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEndUtime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.log_transform.MarkSliceEnd.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.log_transform.MarkSliceEnd.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.log_transform.MarkSliceEnd} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.log_transform.MarkSliceEnd.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      pbtypes_gen_uuid_util_uuid_pb.Uuid.serializeBinaryToWriter
    );
  }
  f = message.getEndUtime();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional uuid_util.Uuid uuid = 1;
 * @return {?proto.uuid_util.Uuid}
 */
proto.log_transform.MarkSliceEnd.prototype.getUuid = function() {
  return /** @type{?proto.uuid_util.Uuid} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_uuid_util_uuid_pb.Uuid, 1));
};


/**
 * @param {?proto.uuid_util.Uuid|undefined} value
 * @return {!proto.log_transform.MarkSliceEnd} returns this
*/
proto.log_transform.MarkSliceEnd.prototype.setUuid = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.log_transform.MarkSliceEnd} returns this
 */
proto.log_transform.MarkSliceEnd.prototype.clearUuid = function() {
  return this.setUuid(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.log_transform.MarkSliceEnd.prototype.hasUuid = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 end_utime = 2;
 * @return {number}
 */
proto.log_transform.MarkSliceEnd.prototype.getEndUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.log_transform.MarkSliceEnd} returns this
 */
proto.log_transform.MarkSliceEnd.prototype.setEndUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.log_transform.MarkSliceRequest.oneofGroups_ = [[2,3]];

/**
 * @enum {number}
 */
proto.log_transform.MarkSliceRequest.StartOrEndCase = {
  START_OR_END_NOT_SET: 0,
  START: 2,
  END: 3
};

/**
 * @return {proto.log_transform.MarkSliceRequest.StartOrEndCase}
 */
proto.log_transform.MarkSliceRequest.prototype.getStartOrEndCase = function() {
  return /** @type {proto.log_transform.MarkSliceRequest.StartOrEndCase} */(jspb.Message.computeOneofCase(this, proto.log_transform.MarkSliceRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.log_transform.MarkSliceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.log_transform.MarkSliceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.log_transform.MarkSliceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.log_transform.MarkSliceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
utime: jspb.Message.getFieldWithDefault(msg, 1, 0),
start: (f = msg.getStart()) && proto.log_transform.MarkSliceStart.toObject(includeInstance, f),
end: (f = msg.getEnd()) && proto.log_transform.MarkSliceEnd.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.log_transform.MarkSliceRequest}
 */
proto.log_transform.MarkSliceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.log_transform.MarkSliceRequest;
  return proto.log_transform.MarkSliceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.log_transform.MarkSliceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.log_transform.MarkSliceRequest}
 */
proto.log_transform.MarkSliceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUtime(value);
      break;
    case 2:
      var value = new proto.log_transform.MarkSliceStart;
      reader.readMessage(value,proto.log_transform.MarkSliceStart.deserializeBinaryFromReader);
      msg.setStart(value);
      break;
    case 3:
      var value = new proto.log_transform.MarkSliceEnd;
      reader.readMessage(value,proto.log_transform.MarkSliceEnd.deserializeBinaryFromReader);
      msg.setEnd(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.log_transform.MarkSliceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.log_transform.MarkSliceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.log_transform.MarkSliceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.log_transform.MarkSliceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUtime();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getStart();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.log_transform.MarkSliceStart.serializeBinaryToWriter
    );
  }
  f = message.getEnd();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.log_transform.MarkSliceEnd.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 utime = 1;
 * @return {number}
 */
proto.log_transform.MarkSliceRequest.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.log_transform.MarkSliceRequest} returns this
 */
proto.log_transform.MarkSliceRequest.prototype.setUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional MarkSliceStart start = 2;
 * @return {?proto.log_transform.MarkSliceStart}
 */
proto.log_transform.MarkSliceRequest.prototype.getStart = function() {
  return /** @type{?proto.log_transform.MarkSliceStart} */ (
    jspb.Message.getWrapperField(this, proto.log_transform.MarkSliceStart, 2));
};


/**
 * @param {?proto.log_transform.MarkSliceStart|undefined} value
 * @return {!proto.log_transform.MarkSliceRequest} returns this
*/
proto.log_transform.MarkSliceRequest.prototype.setStart = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.log_transform.MarkSliceRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.log_transform.MarkSliceRequest} returns this
 */
proto.log_transform.MarkSliceRequest.prototype.clearStart = function() {
  return this.setStart(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.log_transform.MarkSliceRequest.prototype.hasStart = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional MarkSliceEnd end = 3;
 * @return {?proto.log_transform.MarkSliceEnd}
 */
proto.log_transform.MarkSliceRequest.prototype.getEnd = function() {
  return /** @type{?proto.log_transform.MarkSliceEnd} */ (
    jspb.Message.getWrapperField(this, proto.log_transform.MarkSliceEnd, 3));
};


/**
 * @param {?proto.log_transform.MarkSliceEnd|undefined} value
 * @return {!proto.log_transform.MarkSliceRequest} returns this
*/
proto.log_transform.MarkSliceRequest.prototype.setEnd = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.log_transform.MarkSliceRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.log_transform.MarkSliceRequest} returns this
 */
proto.log_transform.MarkSliceRequest.prototype.clearEnd = function() {
  return this.setEnd(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.log_transform.MarkSliceRequest.prototype.hasEnd = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.log_transform.SliceLogEntry.oneofGroups_ = [[1,2,3]];

/**
 * @enum {number}
 */
proto.log_transform.SliceLogEntry.EntryCase = {
  ENTRY_NOT_SET: 0,
  RESOLVED_SLICE: 1,
  MARK_SLICE_START: 2,
  MARK_SLICE_END: 3
};

/**
 * @return {proto.log_transform.SliceLogEntry.EntryCase}
 */
proto.log_transform.SliceLogEntry.prototype.getEntryCase = function() {
  return /** @type {proto.log_transform.SliceLogEntry.EntryCase} */(jspb.Message.computeOneofCase(this, proto.log_transform.SliceLogEntry.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.log_transform.SliceLogEntry.prototype.toObject = function(opt_includeInstance) {
  return proto.log_transform.SliceLogEntry.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.log_transform.SliceLogEntry} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.log_transform.SliceLogEntry.toObject = function(includeInstance, msg) {
  var f, obj = {
resolvedSlice: (f = msg.getResolvedSlice()) && proto.log_transform.ResolvedSlice.toObject(includeInstance, f),
markSliceStart: (f = msg.getMarkSliceStart()) && proto.log_transform.MarkSliceStart.toObject(includeInstance, f),
markSliceEnd: (f = msg.getMarkSliceEnd()) && proto.log_transform.MarkSliceEnd.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.log_transform.SliceLogEntry}
 */
proto.log_transform.SliceLogEntry.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.log_transform.SliceLogEntry;
  return proto.log_transform.SliceLogEntry.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.log_transform.SliceLogEntry} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.log_transform.SliceLogEntry}
 */
proto.log_transform.SliceLogEntry.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.log_transform.ResolvedSlice;
      reader.readMessage(value,proto.log_transform.ResolvedSlice.deserializeBinaryFromReader);
      msg.setResolvedSlice(value);
      break;
    case 2:
      var value = new proto.log_transform.MarkSliceStart;
      reader.readMessage(value,proto.log_transform.MarkSliceStart.deserializeBinaryFromReader);
      msg.setMarkSliceStart(value);
      break;
    case 3:
      var value = new proto.log_transform.MarkSliceEnd;
      reader.readMessage(value,proto.log_transform.MarkSliceEnd.deserializeBinaryFromReader);
      msg.setMarkSliceEnd(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.log_transform.SliceLogEntry.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.log_transform.SliceLogEntry.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.log_transform.SliceLogEntry} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.log_transform.SliceLogEntry.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResolvedSlice();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.log_transform.ResolvedSlice.serializeBinaryToWriter
    );
  }
  f = message.getMarkSliceStart();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.log_transform.MarkSliceStart.serializeBinaryToWriter
    );
  }
  f = message.getMarkSliceEnd();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.log_transform.MarkSliceEnd.serializeBinaryToWriter
    );
  }
};


/**
 * optional ResolvedSlice resolved_slice = 1;
 * @return {?proto.log_transform.ResolvedSlice}
 */
proto.log_transform.SliceLogEntry.prototype.getResolvedSlice = function() {
  return /** @type{?proto.log_transform.ResolvedSlice} */ (
    jspb.Message.getWrapperField(this, proto.log_transform.ResolvedSlice, 1));
};


/**
 * @param {?proto.log_transform.ResolvedSlice|undefined} value
 * @return {!proto.log_transform.SliceLogEntry} returns this
*/
proto.log_transform.SliceLogEntry.prototype.setResolvedSlice = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.log_transform.SliceLogEntry.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.log_transform.SliceLogEntry} returns this
 */
proto.log_transform.SliceLogEntry.prototype.clearResolvedSlice = function() {
  return this.setResolvedSlice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.log_transform.SliceLogEntry.prototype.hasResolvedSlice = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional MarkSliceStart mark_slice_start = 2;
 * @return {?proto.log_transform.MarkSliceStart}
 */
proto.log_transform.SliceLogEntry.prototype.getMarkSliceStart = function() {
  return /** @type{?proto.log_transform.MarkSliceStart} */ (
    jspb.Message.getWrapperField(this, proto.log_transform.MarkSliceStart, 2));
};


/**
 * @param {?proto.log_transform.MarkSliceStart|undefined} value
 * @return {!proto.log_transform.SliceLogEntry} returns this
*/
proto.log_transform.SliceLogEntry.prototype.setMarkSliceStart = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.log_transform.SliceLogEntry.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.log_transform.SliceLogEntry} returns this
 */
proto.log_transform.SliceLogEntry.prototype.clearMarkSliceStart = function() {
  return this.setMarkSliceStart(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.log_transform.SliceLogEntry.prototype.hasMarkSliceStart = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional MarkSliceEnd mark_slice_end = 3;
 * @return {?proto.log_transform.MarkSliceEnd}
 */
proto.log_transform.SliceLogEntry.prototype.getMarkSliceEnd = function() {
  return /** @type{?proto.log_transform.MarkSliceEnd} */ (
    jspb.Message.getWrapperField(this, proto.log_transform.MarkSliceEnd, 3));
};


/**
 * @param {?proto.log_transform.MarkSliceEnd|undefined} value
 * @return {!proto.log_transform.SliceLogEntry} returns this
*/
proto.log_transform.SliceLogEntry.prototype.setMarkSliceEnd = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.log_transform.SliceLogEntry.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.log_transform.SliceLogEntry} returns this
 */
proto.log_transform.SliceLogEntry.prototype.clearMarkSliceEnd = function() {
  return this.setMarkSliceEnd(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.log_transform.SliceLogEntry.prototype.hasMarkSliceEnd = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * @enum {number}
 */
proto.log_transform.StreamType = {
  STREAM_TYPE_UNSPECIFIED: 0,
  STREAM_TYPE_NAVIGATION_CAMERA: 1,
  STREAM_TYPE_USER_CAMERA_AUTONOMY: 2,
  STREAM_TYPE_USER_CAMERA_ROI: 3,
  STREAM_TYPE_USER_CAMERA_INFRARED: 4
};

/**
 * @enum {number}
 */
proto.log_transform.CompressionType = {
  COMPRESSION_TYPE_NONE: 0,
  COMPRESSION_TYPE_ZSTD: 1
};

/**
 * @enum {number}
 */
proto.log_transform.CjiHint = {
  CJI_HINT_UNKNOWN: 0,
  CJI_HINT_POTENTIAL_CJI: 0,
  CJI_HINT_NOT_CJI: 1
};

/**
 * @enum {number}
 */
proto.log_transform.MarkSliceReason = {
  MARK_SLICE_REASON_UNSPECIFIED: 0,
  MARK_SLICE_REASON_GO_TO_WAYPOINT: 1,
  MARK_SLICE_REASON_SUBJECT_TRACKING: 2,
  MARK_SLICE_REASON_ON_DEMAND: 3
};

goog.object.extend(exports, proto.log_transform);
